import { MissionEventHandler } from "../mission"
import { bindData, byId } from "../utils"


export class MissionInfo extends MissionEventHandler {
	constructor(mission, root) {
		super(mission)

		this.root = root

		this.gcsWsUrl = root.getElementsByClassName('gcsWsUrl')[0]

		if (mission.serverState) {
			this.renderState()
		}
	}

	renderState() {
		const data = this.mission.serverState

		bindData(data, byId("missionInfo"))

    let gcsWsUrl = data.dataWsHost ? `ws://${data.dataWsHost}:${data.dataWsPort}` : ''
		this.gcsWsUrl.textContent = gcsWsUrl
	}

  handleSyncCompleted(message) {
		this.renderState()
	}
  handleMissionHistoryAppend(message) {
		if (message.type == 'MISSION_STATE') {
			this.renderState()
		}
	}
}